import apiClient from 'app/domains/apollo';
import { UpdateDocumentContent } from './mutation';
export const saveDocument = (documentId, htmlBody, cloudVersionNumber) => apiClient.mutate({
    mutation: UpdateDocumentContent,
    variables: { documentId, input: { htmlBody, cloudVersionNumber } },
});
